module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noData":"No New Alertn","viewAllalerts":"View All Alerts"},"zh":{"noData":"没有新告警","viewAllalerts":"查看更多"}}')
  delete Component.options._Ctor
}
